// extracted by mini-css-extract-plugin
export default {"cardContainer":"secondTab_cardContainer__pPJ0i","card":"secondTab_card__Y8PNP","card_img":"secondTab_card_img__NhLZY","card_body":"secondTab_card_body__a18iz"};